var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 41,
    viewBox: "0 0 198 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30227_101589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 40H1L1 13H13V40Z",
    fill: "#FAE232",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13H1L1 8L8 1L13 1V13Z",
    fill: "#FAE232",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 1H13V40H186V1Z",
    fill: "#FAE232",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 1H197V29H186V1Z",
    fill: "#FAE232",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 29H197V33.5833L190.583 40H186V29Z",
    fill: "#FAE232",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_30227_101589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5117 1.01001H7.51172L1.01172 7.51001V12.51",
    stroke: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 39.99H190.5L197 33.49V28.49",
    stroke: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.512 39.99H12.5117",
    stroke: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5 1.01001H12.5",
    stroke: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51172 12.5H0.511719V40.46H1.51172V12.5Z",
    fill: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5117 39.49H0.511719V40.49H12.5117V39.49Z",
    fill: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.03 0.51001H185.5V1.51001H197.03V0.51001Z",
    fill: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 0.51001H196.5V28.49H197.5V0.51001Z",
    fill: "#82742A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.469 0.5H197.469V5.12",
    stroke: "#F0DB3D",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 40.49H0.5V35.27",
    stroke: "#F0DB3D",
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30227_101589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 40,
    fill: "white",
    transform: "translate(1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_30227_101589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197.97,
    height: 40.99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSelected);
export default __webpack_public_path__ + "static/media/navigation-selected.9919bc7dfed8bb8d8a8c20d63f5e125a.svg";
export { ForwardRef as ReactComponent };